import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import { getUserState } from '@carvana/core-auth';
import { BCID } from '../constants';
import { getMyCarsReskinBucket, isMyCarsReskinFixed } from './myCarsReskinExperiment';
import { getOrCreateSessionId } from './session-id';

// setUser replaces the whole user object rather than merging, so every caller has to send the
// full set. Kept here as the single definition so the logout re-sync cannot drift from init.
export const setDataDogUser = () => {
  datadogRum.setUser({
    // must use id since datadog's queryable columns are not dynamic
    id: Cookies.get(BCID),
    userId: getUserState().user?.user_id,
    correlationId: getOrCreateSessionId(),
  });
};

const initDataDog = () => {
  datadogRum.init({
    applicationId: '14f8c877-f3e6-43bf-b378-94001d63e92a',
    clientToken: 'pub7ffbb47ea98a4fab5aecb1c7462db695',
    site: 'datadoghq.com',
    service: 'my-carvana-op',
    env: process.env.NODE_ENV,
    // Specify a version number to identify the deployed version of the application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // Mask only user-typed input in session replays; on-screen text stays visible so
    // replays are readable during testing/rollout. Note: this no longer masks static
    // on-screen PII (customer name, vehicle, address), only form inputs.
    defaultPrivacyLevel: 'mask-user-input',
  });

  setDataDogUser();

  datadogRum.startSessionReplayRecording();

  datadogRum.setGlobalContextProperty('controlFixed', isMyCarsReskinFixed());
  datadogRum.setGlobalContextProperty('myCarsReskinBucket', getMyCarsReskinBucket());
};

export default initDataDog;
